module.exports = {
  AFRAME_INJECTED: "aframe-injected",
  DEFAULT_CAMERA_HEIGHT: 1.75,
  DEFAULT_HANDEDNESS: "right",
  keyboardevent: require("./keyboardevent"),
};
